import updateOrderAction from "./updateOrderAction";
import getSurchargedCartAction from "./getSurchargedCartAction";

const setDeliveryMethod = async (get, session, deliveryMethod) => {
    const currentDeliveryMethod = get().input?.deliveryMethod;
    const returnVal = {};
    if(currentDeliveryMethod !== deliveryMethod) {
        await updateOrderAction(session, get, 'DeliveryViaRule', deliveryMethod);
        const refreshedOrder = await getSurchargedCartAction(session, false, get);
        for(const k of Object.keys(refreshedOrder)) {
            returnVal[k] = refreshedOrder[k];
        }
    }
    const currentInput = get().input || {};
    return {...returnVal, input: { ...currentInput, deliveryMethod, deliveryDate: null }};
}

export default setDeliveryMethod;